import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

interface CannotArchiveProcessItemsModalProps {
  onRequestClose: () => void;
  title: string;
  body: string;
}

const CannotArchiveProcessItemsModal = (props: CannotArchiveProcessItemsModalProps): JSX.Element => (
  <Modal
    onRequestClose={props.onRequestClose}
    closeableOnBackgroundClick={true}
    closeableOnEscapeKey={true}
    buttons={[
      {
        text: 'Cancel',
        style: ButtonStyle.TERTIARY_GRAY,
        dataTestAttrs: {component: 'CannotArchiveProcessItemsModal', element: 'cancelButton'},
        cancel: true,
      },
    ]}
    title="Error"
    dataTestAttrs={{component: 'CannotArchiveProcessItemsModal', element: 'root'}}
    expandHeight={true}
  >
    {props.body}
  </Modal>
);

export default CannotArchiveProcessItemsModal;
